export default __webpack_public_path__ + "static/media/AboutImg.893722de.png";